import React, { useEffect, useState } from "react";
import axios from "../import/axiosConfig";
import Swal from "sweetalert2";
const PartyTransactionDetails = () => {
  const [transactions, setTransactions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [transactionText, setTransactionText] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  useEffect(() => {
    fetchPaymentDetails();
  }, []);

  // const fetchPaymentDetails = async () => {
  //   try {

  //     const userData = JSON.parse(localStorage.getItem("userData"));
  //     const database = userData?.database;

  //     const res = await axios.get(`/order/view-payment-details/${database}`);
  //     setTransactions(res?.data?.paymentDetails || []);

  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const fetchPaymentDetails = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem("userData"));
      const database = userData?.database;

      const res = await axios.get(`/order/view-payment-details/${database}`);
      let data = res?.data?.paymentDetails || [];

      // 🔽 Latest date/time ऊपर लाने के लिए sorting
      data.sort((a, b) => {
        const dateA = new Date(`${a.Date} ${a.Time}`);
        const dateB = new Date(`${b.Date} ${b.Time}`);
        return dateB - dateA; // 🔥 latest first
      });

      setTransactions(data);
    } catch (error) {
      console.log(error);
    }
  };

  const saveTransaction = async () => {
    try {
      let utrNumber = "";
      let date = new Date().toLocaleDateString();
      let time = new Date().toLocaleTimeString();

      // 🔍 UTR extract
      const match = transactionText.match(/\d{10,18}/);

      if (match) {
        utrNumber = match[0];
      }

      // ❌ UTR not found
      if (!utrNumber) {
        Swal.fire({
          icon: "warning",
          title: "UTR Not Found",
          text: "Please enter valid transaction details",
        });
        return;
      }

      const payload = {
        id: selectedId,
        paidAmount: selectedItem?.paidAmounts || 0,
        transactionDetails: {
          utrNumber: utrNumber,
          date: date,
          time: time,
        },
      };

      console.log("Payload:", payload);

      // 🔄 Loading Swal
      Swal.fire({
        title: "Saving...",
        text: "Please wait",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      await axios.post("/order/qrcode-payment", payload);

      // ✅ Success Swal
      Swal.fire({
        icon: "success",
        title: "Transaction Saved ✅",
        timer: 1500,
        showConfirmButton: false,
      });

      setShowModal(false);
      setTransactionText("");

      fetchPaymentDetails();
    } catch (err) {
      console.log(err);

      // ❌ Error Swal
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to save transaction ❌",
      });
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>Party Transaction Details</h2>

      <table
        border="1"
        cellPadding="8"
        cellSpacing="0"
        style={{ width: "100%", textAlign: "center" }}
      >
        <thead style={{ background: "#f2f2f2" }}>
          <tr>
            <th>Date</th>
            <th>Time</th>
            <th>Party ID</th>
            <th>Invoice No</th>
            <th>Status</th>
            {/* <th>Verify</th> */}
            <th style={{ width: "160px" }}>Transaction</th>
          </tr>
        </thead>

        <tbody>
          {transactions.map((item, index) => (
            <tr key={index}>
              <td>{item?.Date}</td>
              <td>{item?.Time}</td>
              <td>{item?.partyId}</td>
              <td>{item?.invoiceId}</td>
              <td>{item?.statusQr}</td>

              {/* <td
                style={{
                  color: item?.paymentVerified ? "green" : "red",
                  fontWeight: "600"
                }}
              >
                {item?.paymentVerified ? "Yes" : "No"}
              </td> */}

              {/* Transaction Button Right Side */}
              <td style={{ textAlign: "right" }}>
                <button
                  style={{
                    background: "#007bff",
                    color: "#fff",
                    border: "none",
                    padding: "4px 10px",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setSelectedId(item._id);
                    setSelectedItem(item);
                    setShowModal(true);
                  }}
                >
                  Transaction Details
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Modal */}
      {/* Modal */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "20px",
              width: "420px",
              borderRadius: "6px",
            }}
          >
            <h3>Paste Transaction Details</h3>

            {/* Show Selected ID */}
            <div style={{ marginBottom: "10px", fontSize: "14px" }}>
              <b>Invoice ID :</b> {selectedId}
            </div>

            <textarea
              value={transactionText}
              onChange={(e) => setTransactionText(e.target.value)}
              placeholder="Paste transaction details here"
              style={{
                width: "100%",
                height: "120px",
                marginBottom: "10px",
                padding: "6px",
              }}
            />

            <div style={{ textAlign: "right" }}>
              <button
                onClick={() => setShowModal(false)}
                style={{ marginRight: "10px" }}
              >
                Close
              </button>

              <button
                onClick={saveTransaction}
                style={{
                  background: "green",
                  color: "#fff",
                  border: "none",
                  padding: "6px 14px",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PartyTransactionDetails;
